import { OutboundLink } from "gatsby-plugin-google-gtag";
import * as React from 'react';
export default {
  OutboundLink,
  React
};